import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import socket from "../../../../context/socket";
import _ from "lodash";
import YearSelect from "../../StartedYear/year";
import { fetchClientData } from "../../../../redux/client/clientSlice";
import { useDispatch } from "react-redux";
import api from "../../../../utils/api";

const CarPurchaseData = ({ roomId, card_id, planYourGoals }) => {
  const [selectedCard, setSelectedCard] = useState(null);
  const dispatch = useDispatch();

  const [carPurchaseInputData, setCarPurchaseInputData] = useState({
    amount: "",
    goalYear: "",
    downPayment: "",
    startYear: new Date().getFullYear().toString(),
  }
  );
  console.log("carPurchaseInputData", carPurchaseInputData);

  // Fetch the selected card and set the initial data
  useEffect(() => {
    if (planYourGoals && card_id) {
      const card = planYourGoals.find((item) => item._id === card_id);
      setSelectedCard(card);

      // If action_data exists, map it to retirementInputData
      if (card?.action_data?.[0]) {
        const { amount, goalYear, downPayment, startYear } =
          card.action_data[0];
        setCarPurchaseInputData({
          amount,
          goalYear,
          downPayment,
          startYear: startYear || new Date().getFullYear().toString(),
        });
      }
      else {
        setCarPurchaseInputData((prev) => ({
          ...prev,
          startYear: new Date().getFullYear().toString(),
        }));
      }
    }
  }, [planYourGoals, card_id]);

  // Function to save data via API
  const saveData = async (updatedData) => {
    try {
      // Check if all fields are filled
      const allFieldsFilled =
        updatedData.amount !== "" &&
        updatedData.goalYear !== "" &&
        updatedData.downPayment !== "" &&
        updatedData.startYear !== "";

      // Add the status field to updatedData
      // const dataWithStatus = {
      //   ...updatedData,
      //   status: allFieldsFilled ? 1 : 0,
      // };


      const newStatus = allFieldsFilled ? 1 : 0;
      const prevCreatedAt = selectedCard?.created_at;

      const dataWithStatus = {
        ...updatedData,
        status: newStatus,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [dataWithStatus],
        status: newStatus,
      };

      // ✅ Add created_at ONLY ONCE at ROOT
      if (newStatus === 1 && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }

      console.log('dataWithStatus', newStatus, prevCreatedAt);

      // Send the data with the status field
      const response = await api.post(`advisor/save_goal_data`,payload);
      dispatch(fetchClientData(roomId));
      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  // Debounced save function
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [selectedCard]
  );

  // Handle input changes
  const handleCarPurchaseInputData = (field, value) => {
    const updatedData = { ...carPurchaseInputData, [field]: value };
    setCarPurchaseInputData(updatedData);

    // Trigger the debounced save function
    debouncedSaveData(updatedData);
  };

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          carPurchaseInputData,
        },
      });
    }, 300),
    [selectedCard, roomId, carPurchaseInputData]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [selectedCard, debouncedEmitMessage, carPurchaseInputData]);

  return (
    <>
      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            My dream car costs{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: "8%",
                  minWidth: `${(carPurchaseInputData?.amount || "").length + 2
                    }ch`,
                }}
                className="clrgreen fw-bold ps-3 moinput"
                value={carPurchaseInputData?.amount}
                // onChange={(e) =>
                //   handleCarPurchaseInputData("amount", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleCarPurchaseInputData("amount", value)
                  }
                }}
                placeholder="0"
              />
            </span>{" "}
            <span>today, and I plan to buy it by</span>
            <input
              type="text"
              style={{
                border: "none",
                borderBottom: "1px solid green",
                width: "8%",
                minWidth: `${(carPurchaseInputData?.goalYear || "").length + 2
                  }ch`,
              }}
              className="clrgreen fw-bold ps-3 moinput"
              value={carPurchaseInputData?.goalYear}
              // onChange={(e) =>
              //   handleCarPurchaseInputData("goalYear", e.target.value)
              // }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  handleCarPurchaseInputData("goalYear", value)
                }
              }}
              placeholder="Year"
            />
          </p>
        </div>
      </div>

      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I want to save up for a{" "}
            <span className="clrgreen fw-semibold">
              <input
                type="text"
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: "5%",
                  minWidth: `${(carPurchaseInputData?.downPayment || "").length + 2
                    }ch`,
                }}
                className="clrgreen fw-bold ps-3 moinput"
                value={carPurchaseInputData?.downPayment}
                // onChange={(e) =>
                //   handleCarPurchaseInputData("downPayment", e.target.value)
                // }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleCarPurchaseInputData("downPayment", value)
                  }
                }}
                placeholder="0"
              />
            </span>{" "}
            % down payment on my dream machine and finance the rest.
          </p>
        </div>
      </div>

      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            Start Year{" "}
            <span className="clrgreen fw-semibold">
              <select
                style={{
                  border: "none",
                  borderBottom: "1px solid green",
                  width: `${
                    (carPurchaseInputData?.startYear || "").length + 3
                  }ch`,
                  paddingLeft: "1rem",
                  minWidth: "8ch",
                }}
                className="clrgreen fw-bold ps-3 moinput"
                value={carPurchaseInputData?.startYear}
                onChange={(e) =>
                  handleCarPurchaseInputData("startYear", e.target.value)
                }
              >
                <option value="">Select</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </span>{" "}
          </p>
        </div>
      </div> */}

      <div className="row ps-3 align-items-center">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>

        <div className="col-md-9 col-10 d-flex align-items-center">
          <p className="fs-21 lh-sm me-2 pt-3">Start Year:</p>
          <div style={{ minWidth: "120px" }}>
            <YearSelect
              value={carPurchaseInputData?.startYear}
              onChange={(val) => handleCarPurchaseInputData("startYear", val)}
              recentYear={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>
    </>
  );
};

// Debounce function
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

export default CarPurchaseData;
